import { Container } from "react-bootstrap";

const PaymentMethod = () => {
  return <Container>hai</Container>;
};

export default PaymentMethod;
